/** Every page of the site. New pages (games 2 and 3, museum sections) are added here. */
export const paths = {
  home: "/",
  drop: "/drop",
  stack: "/stack",
  breaker: "/breaker",
} as const;
